(function () {
  'use strict';
  const directCheckoutProducts = new Set(['house', 'wall-text']);
  const directCheckoutMountings = new Set(['product-only', 'self-adhesive-inside', 'glue-kit']);
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ds-checkout]');
    if (!button) return;
    const host = button.closest('dunesign-configurator');
    if (!host || host.dataset.checkoutEnabled !== 'true' || host.checkoutPending) return;
    host.update();
    const current = host.current;
    if (!current) return;
    const state = current.state;
    if (!directCheckoutProducts.has(state.type) || !state.text || !state.substrate || !directCheckoutMountings.has(state.mountingChoice)) {
      host.setStatus('Gebruik voor deze samenstelling de knop om je bestelling persoonlijk te laten controleren.', true);
      return;
    }
    const configuration = {
      productKey: state.type, text: state.text, fontKey: state.font.key,
      heightCm: state.heightCm, application: state.application,
      color: state.colorTechnicalName, suffixMode: state.suffixMode,
      surface: state.surface, substrate: state.substrate, mounting: state.mountingChoice,
    };
    const body = {configuration, expectedTotalCents: current.totalPriceCents, revision: host.dataset.checkoutRevision};
    const fingerprint = JSON.stringify(body);
    const storageKey = 'dunesign:checkout-attempt:v1';
    try {
      const previous = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      body.requestId = previous?.fingerprint === fingerprint ? previous.requestId : crypto.randomUUID();
      sessionStorage.setItem(storageKey, JSON.stringify({fingerprint, requestId: body.requestId}));
    } catch {
      host.setStatus('We kunnen je bestelreferentie niet bewaren. Gebruik de persoonlijke controle.', true);
      return;
    }
    host.checkoutPending = true;
    button.disabled = true;
    const label = button.textContent;
    button.textContent = 'Beveiligde checkout openen…';
    host.setStatus('Je gaat nu verder naar de beveiligde Shopify-checkout.');
    try {
      const response = await fetch('/apps/dunesign-click-pay/checkout', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body), signal: AbortSignal.timeout(30000),
      });
      const contentType = response.headers.get('content-type') || '';
      let result = null;
      if (contentType.includes('application/json')) {
        try { result = await response.json(); } catch { result = null; }
      }
      if (!response.ok || !result) {
        throw new Error('De beveiligde betaalroute is tijdelijk niet beschikbaar. Kies persoonlijke controle of probeer later opnieuw.');
      }
      if (result.ok === false || !result.checkoutUrl) {
        throw new Error(result.error || 'De bestelling kon niet worden voorbereid.');
      }
      const target = new URL(result.checkoutUrl);
      if (target.protocol !== 'https:' || target.hostname !== window.location.hostname || result.totalCents !== body.expectedTotalCents) {
        throw new Error('De betaalgegevens vragen een controle. Gebruik de persoonlijke controle.');
      }
      window.location.assign(target.href);
    } catch (error) {
      host.setStatus(error.name === 'TimeoutError' ? `De verbinding is onderbroken. Neem contact op met Dunesign en vermeld DS-${body.requestId}.` : error.message, true);
    } finally {
      host.checkoutPending = false;
      button.disabled = false;
      button.textContent = label;
    }
  });
})();
